import { render, staticRenderFns } from "./FormGuideSortSelect.vue?vue&type=template&id=95a82dd6"
import script from "./FormGuideSortSelect.vue?vue&type=script&lang=js"
export * from "./FormGuideSortSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports